export default {
  // Este componente não tem strings estáticas traduzíveis
  // Usa dados dinâmicos passados de props (title)
}
